var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "path",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M18.836 36.025c.369.216.554.323.814.38.202.042.497.042.699 0 .26-.057.445-.164.814-.38 3.246-1.894 12.17-7.844 12.17-16.024V12.03c0-1.333 0-1.999-.218-2.572a3.333 3.333 0 0 0-.912-1.315c-.46-.405-1.083-.639-2.331-1.107l-8.936-3.35c-.347-.13-.52-.196-.698-.222a1.666 1.666 0 0 0-.477 0c-.178.026-.351.091-.698.221l-8.936 3.351c-1.248.468-1.872.702-2.332 1.107-.406.358-.719.81-.911 1.315-.218.573-.218 1.24-.218 2.572V20c0 8.181 8.923 14.131 12.17 16.025Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield);
export default __webpack_public_path__ + "static/media/shield.2e0229cc64344b1199009f3d86562279.svg";
export { ForwardRef as ReactComponent };